import { Switch, Route } from "react-router-dom";

import Header from "./components/Header/Header";
import Profile from "./components/Profile";
import Story from "./components/Story";
import Reels from "./components/Reels";
import Post from "./components/Post";
import Igtv from "./components/Igtv";
import Error from "./components/Error";
import Footer from "./components/Footer/Footer";

import "./App.css";
import "./components/Styles/commonStyles.css";


const App = () => {
    return (
        <>
            <Header />
            <Switch>
                <Route exact path="/HannanMaxIG/" component={Profile} />
                <Route path="/HannanMaxIG/profile" component={Profile} />
                <Route path="/HannanMaxIG/story" component={Story} />
                <Route path="/HannanMaxIG/reel" component={Reels} />
                <Route path="/HannanMaxIG/post" component={Post} />
                <Route path="/HannanMaxIG/igtv" component={Igtv} />
                <Route component={Error} />
                <Route />
            </Switch>
            <Footer />
        </>
    );
};

export default App;
